<template>
    <div class="home-box">
        <PageTitle :title="'Edit Store'" class="py-5"></PageTitle>
        <v-row align="center">
        <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
          <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div class="col-md-12 home-tabs-body">
  
          <StoreEditForm></StoreEditForm>
        </div>
      </v-row>
    </div>
  </template>
  
  <script>
  
  import PageTitle from "@/components/shared/PageTitle";
  import StoreEditForm from "../../components/storesAndStocks/StoreEditForm.vue";
  
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name:"batchEdit",
  
    components:{
        PageTitle,
        StoreEditForm
    },
    data: function () {
      return {
        role: localStorage.getItem('role') || null,
        editMode: false,
        loading: false
      };
    },
    computed: {
      ...mapGetters({
        profile: "profile",
      }),
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
      this.$store.dispatch("settings/getCompanySettings");
    },
  
    watch: {
    }
  
  
  
  }
  
  
  
  </script>